<template>
  <v-card class="elevation-0">
    <v-toolbar
      card
      dense
      color="transparent"
    >
      <v-toolbar-title>
        <h4>Notification</h4>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list
        two-line
        class="pa-0"
      >
        <template v-for="(item, index) in items">

          <v-list-tile
            avatar
            @click="handleClick(item)"
          >
            <v-list-tile-avatar color="primary">
              <v-icon dark>speaker_notes</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title v-html="item.notification"></v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.notificationType}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="caption">
              {{item.notificationTime}}
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <!-- <v-divider></v-divider>
      <v-btn
        block
        flat
        class="ma-0"
      >All</v-btn>
      <v-divider></v-divider> -->
    </v-card-text>
  </v-card>
</template>

<script>
import { updateNotification } from '@/api/notification';
export default {
  data: () => ({
    items: []
  }),
  created () {

  },
  methods: {
    handleClick (item) {

      let index = this.items.indexOf(item);
      this.items.splice(index, 1);

      updateNotification(item)
        .then(response => {

        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/widgets/list/NotificationList.vue